import { useAtom } from "jotai";
import { themeAtom } from "../stores/theme";

export default function ThemeToggle() {
  const [theme, setTheme] = useAtom(themeAtom);

  const toggle = () => {
    const next = theme === "dark" ? "light" : "dark";
    setTheme(next);
    document.documentElement.classList.toggle("light", next === "light");
    localStorage.setItem("theme", next);
  };

  return (
    <button
      onClick={toggle}
      className="flex w-full items-center gap-md rounded-lg px-md py-md text-sm text-gruvbox-gray hover:glass-subtle hover:text-gruvbox-fg transition-all"
    >
      <span>{theme === "dark" ? "\u2600" : "\u263E"}</span>
      {theme === "dark" ? "Light mode" : "Dark mode"}
    </button>
  );
}
